import { mapActions } from 'vuex';

export default {
  // computed: {
  //   userHasProvidedFile() {
  //     return this.uploadedFiles && this.uploadedFiles.length > 0;
  //   },
  // },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'uploadFile',
    ]),
    fillFormData(formData, i) {
      const index = parseInt(i, 10) + 1;

      formData.append('uploadname', `${this.filePrefix}${this.lead.id}_${index}`);
      formData.append('agentkey', this.$route.params.ak);
      // formData.append('agentkey', this.agent.key);
      // formData.append('userkey', this.agent.userkey);
      formData.append('userkey', !!this.user && !!this.user.key ? this.user.key : this.agent.userkey);
      formData.append('leadkey', this.lead.key);
      formData.append('uploadtypeid', this.fileType);
      return formData;
    },
    // fileUploading() {
    //   this.disableSubmit = true;
    // },
    // fileUploaded(values) {s
    //   this.uploadedFiles = values.files;
    //   this.disableSubmit = false;
    // },
    // upload() {
    //   return new Promise((resolve, reject) => {
    //     if (this.userHasProvidedFile) {
    //       this.disableSubmit = true;
    //       this.uploadFiles()
    //         .then(() => {
    //           this.disableSubmit = false;
    //           resolve(true);
    //         });
    //     } else {
    //       reject('No file uploaded');
    //     }
    //   });
    // },
    // uploadFiles() {
    //   return Promise.all(
    //     this.uploadedFiles.map((file, i) => this.uploadFile(this.prepareFormData(i))),
    //   );
    // },
    // prepareFormData(i) {
    //   const reader = new FileReader();
    //   reader.readAsDataURL(this.uploadedFiles[i]);

    //   const formData = new FormData();
    //   const index = parseInt(i, 10) + 1;

    //   formData.append('file', this.uploadedFiles[i]);
    //   formData.append('uploadname', `${this.filePrefix}${this.lead.id}_${index}`);
    //   formData.append('agentkey', this.agent.key);
    //   formData.append('userkey', this.agent.userkey);
    //   formData.append('leadkey', this.lead.key);
    //   formData.append('uploadtypeid', this.fileType);

    //   return formData;
    // },
  },
};
